import localforage from "localforage";
import "localforage-getitems";
import { extendPrototype } from "localforage-setitems";

extendPrototype(localforage);

const INDEXED_DB_NAME = "LUTs Previewer";
const INDEXED_DB_DESCRIPTION = "Lutify.me - LUTs Previewer";
const INDEXED_DB_VERSION = 1.0;
export const INDEXED_DB_VERSION_LUT_CONTROLS = 1.1;
export const INDEXED_DB_VERSION_LUT_SLIDERS = 1.1;
export const INDEXED_DB_VERSION_SYSTEM_LUTS = 1.1;

// Removing old DB
// localforage.dropInstance({
// 	name: 'Lutify'
// });

localforage.config({
	name: INDEXED_DB_NAME,
	description: INDEXED_DB_DESCRIPTION,
	version: INDEXED_DB_VERSION
});

class IDBService {
	constructor(storeName) {
		this.storeName = storeName
	}

	createInstance() {
		return localforage.createInstance({
			name: INDEXED_DB_NAME,
			storeName: this.storeName,
			description: INDEXED_DB_DESCRIPTION,
		})
	}

	clear() {
		return this.createInstance().clear();
	}

	removeItem(key) {
		return this.createInstance().removeItem(key);
	}

	getItem(key) {
		return this.createInstance().getItem(key);
	}

	async getItems(keys) {
		if (keys) {
			let result = await this.createInstance().getItems(keys);
			return Object.fromEntries(Object.entries(result).filter(([_, v]) => v != null));
		}

		else return await this.createInstance().getItems();
	}

	setItem(key, data) {
		return this.createInstance().setItem(key, data);
	}

	setItems(data) {
		return this.createInstance().setItems(data);
	}
}

export const versionStore = new IDBService('Version');
export const UserStore = new IDBService('User');
export const LUTcontrolsStore = new IDBService('LUTcontrols');
export const LUTslidersStore = new IDBService('LUTsliders');
export const systemLutsStore = new IDBService('SystemLuts');
export const imagesStore = new IDBService('Images');
export const candidatesStore = new IDBService('Candidates');
export const imagesStateStore = new IDBService('Images state');
export const customLutsStore = new IDBService('Custom Luts');
export const blocksStore = new IDBService('Blocks');
export const defaultsStore = new IDBService('Defaults');
